module.exports = __webpack_public_path__ + "img/20190416.b99da7bc.png";